<template>
  <div class="footers">
    <div class="container">
      <div class="top flexCenter">
        <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/heilogo@2x.png" alt="">
        <div class="intro">
          <p>一站式写字楼管理服务平台</p>
          <p>租房平台（C2C+C2B）+租赁管理</p>
        </div>
      </div>
      <div class="middle">
        <div class="left">
          <div class="flex">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/kefu.png" alt="">
            <p>4000-989-222</p>
          </div>
          <div class="flex">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/youxiang.png" alt="">
            <p>邮箱：zdy@zhidingcloud.com</p>
          </div>
          <div class="flex">
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/dizhi.png" alt="">
            <p>地址：武汉东湖新技术开发区光谷创业街66-6号海达创新广场13楼</p>
          </div>
        </div>
        <div class="right flex">
          <div>
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/gongzh@2x.png" alt="">
            <p>微信公众号</p>
          </div>
          <div>
            <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/gongzh@2x.png" alt="">
            <p>智鼎云APP</p>
          </div>
        </div>
      </div>
      <div class="cooperate">
        <h3>合作单位</h3>
        <div class="spaceBetween">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/1.png" alt="">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/2.png" alt="">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/3.png" alt="">
          <img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/add/4.png" alt="">
        </div>
      </div>
      <div class="bottom">
        <p>Copyright © 2019 ZHIDINGCLOUD CO,.LTD.保留所有权利 鄂ICP备19022417号-1</p>
        <p>智鼎云（www.zhidingcloud.com©️2019）All Rights Resrved</p>
        <div class="bottom-text-box"><img src="https://zdcloud-oss.oss-cn-hangzhou.aliyuncs.com/website/assets/home/beian@2x.png" alt="" class="police"><p>鄂公网安备 42018502004182</p> <span @click.stop="$router.push('/explain')" class="explain">隐私政策说明</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      
    };
  },
  methods: {
    init() {}
  },
  created() {
    this.init();
  }
};
</script>

<style lang='less' scoped>
@import "~style/index";
p{
  margin:0;
}

.footers{
  width: 100%;
  background: #fff;
  border-top:1px solid #EEEEEE;
  .container{
    max-width: 1200px;
    padding:60px 0;
    margin: 0 auto;
    .top{
      img{
        width: 194px;
        margin-right:40px;
        object-fit: contain;
      }
      .intro{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 60px;
        p{
          font-weight:bold;
          color:rgba(51,51,51,1);
        }
      }
    }
    .middle{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin:60px 0;
      .left{
        .flex{
          align-items: center;
          margin-bottom:10px;
          img{
            width: 24px;
            height: 20px;
            margin-right:20px;
          }
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
          }
        }
      }
      .right{
        div:first-child{
          margin-right:50px;
        }
        img{
          width: 128px;
          margin-bottom:10px;
        }
        p{
          font-size:18px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          line-height:24px;
          text-align: center;
        }
      }
    }
    .cooperate{
      h3{
        font-size:24px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:53px;
        margin:20px 0;
      }
      .spaceBetween{
        width: 100%;
        margin-bottom:40px;
        img{ 
          height: 120px;
          min-width: 1px;
          margin-right: 10px;
        }
        img:last-child{
          margin:0;
        }
      }
    }
    .bottom{
      p{
        font-size:16px;
        font-weight:400;
        color:rgba(102,102,102,1);
        text-align: center;  
        margin-bottom:10px;
      }
      .bottom-text-box{
        text-align: center;
        font-size:16px;
        display: flex;
        align-items: center;
        justify-content: center;
        p{
          margin:0;
        }
        .explain{
          color:black;
          margin-left:20px;
          cursor: pointer;
        }
      }
      .police{
        width: 18px;
        vertical-align: middle;
        margin-right: 12px;
      }
    }
  }
}
</style>